import { BoltConnectionReadDto } from '../_generated/api/structure'
import { BoltConnectionBoltDetailsDto } from '../_generated/api/tagged-hardware'
import { StructureTypes } from './Structure'
import ApiStructureModel from './ApiStructureModel'
import ApiModel from './ApiModel'

export default class BoltConnection extends ApiStructureModel<BoltConnectionReadDto> {
    get referenceType() {
        return StructureTypes.BoltConnection
    }

    get constraints() {
        return this.data.boltConstraints ?? {}
    }

    get pretensionForceMin() {
        return this.constraints.pretensionForceMinKn ?? undefined
    }

    get pretensionForceMax() {
        return this.constraints.pretensionForceMaxKn ?? undefined
    }

    get characteristicPretensionForceMin() {
        return this.constraints.characteristicPretensionForceMinKn ?? undefined
    }

    get linearForceConstant() {
        return this.constraints.springConstantKnMm ?? undefined
    }

    get expectedNominalLength() {
        return this.constraints.expectedNominalLengthMm ?? undefined
    }

    get expectedNumberOfBolts() {
        return this.constraints.expectedNumberOfBolts ?? undefined
    }

    get expectedBoltType() {
        return this.constraints.expectedBoltType ?? undefined
    }

    get expectedBoltMaterial() {
        return this.constraints.expectedBoltMaterial ?? undefined
    }

    get expectedBoltSize() {
        return this.constraints.expectedBoltSize ?? undefined
    }

    get hasValidPretensionRange() {
        const { pretensionForceMin: min, pretensionForceMax: max } = this
        return !!min && (!max || max > min)
    }
}

export class BoltDetails extends ApiModel<BoltConnectionBoltDetailsDto> {
    get characteristicPretensionForceKn() {
        return this.data.characteristicPretensionForceKn ?? 0
    }

    get averagePretensionForceKn() {
        return this.data.averagePretensionForceKn ?? 0
    }

    get numberOfBoltsInCalculation() {
        return this.data.numberOfBoltsInCalculation ?? 0
    }

    get totalNumberOfBolts() {
        return this.data.totalNumberOfBolts ?? 0
    }
}
